export default __webpack_public_path__ + "static/media/blogDesign.e19887d4.png";